import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {

    const accSections = document.querySelectorAll('.award-certification-carousel');

    accSections.forEach(section => {

        const accSlider = section.querySelector('.acc-slider');
        if (!accSlider) {return;}

        // ✅ Check if rectangle design is selected
        const isRectangle = section.classList.contains('shape-rectangle');

        new Swiper(accSlider, {
            spaceBetween: 32,
            slidesPerView: 1,
            loop: true,

            navigation: {
                prevEl: section.querySelector('.acc-arrow-prev'),
                nextEl: section.querySelector('.acc-arrow-next'),
            },

            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
                1025: {
                    slidesPerView: isRectangle ? 5 : 4, // ✅ 5 for rectangle, 4 for default
                },
            },
        });
    });

});